'use strict';

exports.__esModule = true;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _framesync = require('framesync');
var _calc = require('../inc/calc');
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Action = function () {
  // lawsuit - sorry
  function Action() {
    var _this = this;
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Action);
    this.scheduledUpdate = function () {
      _this.lastUpdated = (0, _framesync.timeSinceLastFrame)();
      _this.prev = _this.current;
      var _props = _this.props,
        onUpdate = _props.onUpdate,
        passive = _props.passive;
      if (_this.update) {
        _this.current = _this.update(_this.current);
      }
      if (onUpdate) {
        if (onUpdate.registerAction) {
          onUpdate.set(_this.get());
        } else {
          onUpdate(_this.get(), _this);
        }
      }
      _this.fireListeners();
      if (!passive && _this._isActive) {
        (0, _framesync.onFrameUpdate)(_this.scheduledUpdate);
      }
      if (_this.isActionComplete && _this.isActionComplete()) {
        _this.complete();
      }
      return _this;
    };
    this.props = _extends({}, this.constructor.defaultProps);
    this.setProps(props);
    this.lastUpdated = 0;
    this.prev = this.current = props.current || props.from || 0;
  }
  Action.prototype.start = function start() {
    var _props2 = this.props,
      onStart = _props2.onStart,
      _onStart = _props2._onStart,
      passive = _props2.passive;
    if (!passive) {
      this._isActive = true;
      (0, _framesync.onFrameUpdate)(this.scheduledUpdate);
    }
    if (this.onStart) this.onStart();
    if (onStart) onStart(this);
    if (_onStart) _onStart(this);
    return this;
  };
  Action.prototype.stop = function stop() {
    var _props3 = this.props,
      onStop = _props3.onStop,
      _onStop = _props3._onStop,
      passive = _props3.passive;
    if (!passive) {
      this._isActive = false;
      (0, _framesync.cancelOnFrameUpdate)(this.scheduledUpdate);
    }
    if (this.onStop) this.onStop();
    if (onStop) onStop(this);
    if (_onStop) _onStop(this);
    return this;
  };
  Action.prototype.complete = function complete() {
    var _props4 = this.props,
      onComplete = _props4.onComplete,
      _onComplete = _props4._onComplete;
    this.stop();
    if (this.onComplete) this.onComplete();
    if (onComplete) onComplete(this);
    if (_onComplete) _onComplete(this);
    return this;
  };
  Action.prototype.setProps = function setProps(_ref) {
    var onUpdate = _ref.onUpdate,
      props = _objectWithoutProperties(_ref, ['onUpdate']);
    this.props = _extends({}, this.props, props);
    if (onUpdate) this.output(onUpdate);
    return this;
  };
  Action.prototype.output = function output(func) {
    this.props.onUpdate = func;
    if (func.registerAction) func.registerAction(this);
    return this;
  };
  Action.prototype.get = function get() {
    var transform = this.props.transform;
    return transform ? transform(this.current) : this.current;
  };
  Action.prototype.getBeforeTransform = function getBeforeTransform() {
    return this.current;
  };
  Action.prototype.set = function set(v) {
    this.current = v;
    return this;
  };
  Action.prototype.getProp = function getProp(key) {
    return this.props[key];
  };
  Action.prototype.getVelocity = function getVelocity() {
    return (0, _calc.speedPerSecond)(this.current - this.prev, this.lastUpdated);
  };
  Action.prototype.isActive = function isActive() {
    return this._isActive;
  };
  Action.prototype.addListener = function addListener(listener) {
    this.listeners = this.listeners || [];
    this.numListeners = this.numListeners || 0;
    if (this.listeners.indexOf(listener) === -1) {
      this.listeners.push(listener);
      this.numListeners++;
    }
    return this;
  };
  Action.prototype.removeListener = function removeListener(listener) {
    var listenerIndex = this.listeners ? this.listeners.indexOf(listener) : -1;
    if (listenerIndex !== -1) {
      this.numListeners--;
      this.listeners.splice(listenerIndex, 1);
    }
    return this;
  };
  Action.prototype.fireListeners = function fireListeners() {
    var current = this.get();
    for (var i = 0; i < this.numListeners; i++) {
      this.listeners[i](current, this);
    }
    return this;
  };
  return Action;
}();
exports.default = Action;